<template>
	<div class="menu-mobile">
		<div class="user-mobile">
			<div class="close-menu" @click="openMenu(false)">
				<img src="@/assets/images/x.svg" />
			</div>
			<div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
				<font-awesome-icon icon="university" size="2x" />
			</div>

			<div id="modal_popup_mobileNotifications" class="modal-popup">
				<div class="modal-popup-content">
					<a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
						<img src="@/assets/images/close-button.svg" />
					</a>
					<div class="notifications">
						<table cellpadding="10" cellspacing="0" width="100%" style="text-align: left" align="center"
							class="hover-table">
							<tr v-for="company in this.user.companies" :key="company.company_id"
								@click="selectCompany(company.company_id)" class="trhover" :class="customer.company_id === company.company_id && 'gri-cell'
									">
								<td class="notification-footer">
									<p>
										<font-awesome-icon icon="university" />

										{{ company.name }}
									</p>
								</td>
								<td class="notification-footer" style="text-align: right">
									<p>{{ company.company_id }}</p>
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>

			<div>
				<img src="@/assets/images/linie.png" />
			</div>
			<div>
				<img src="@/assets/images/settings.png" />
			</div>
			<div>
				<a href="#">{{ this.customer.name | titleCase }}</a>
			</div>
		</div>
		<MenuItems  :menuSelected="this.menuSelected" />
	</div>
</template>
<script>
import $ from "jquery";
import MenuItems from "@/components/company/customer/MenuItems.vue";

export default {
	name: "MenuDesktop",
	props: {
		user: Object,
		menuSelected: Object,
		customer: Object,
	},
	data() {
		return {
		}
	},
	components: {
		MenuItems
	},
	methods: {
		openMenu(open) {
			if (open) {
				$(".menu-mobile").show();
			} else {
				$(".menu-mobile").hide();
			}
		}
	},
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
